import { useEffect, useState } from 'react';
import { userLessonUserList } from 'Api/attendance';

const useFetch = ({ courseId, lessonId }, setIsLoading) => {
  const [employees, setEmployees] = useState([]);
  const [initialAttendanceState, setInitialAttendanceState] = useState();
  const [departments, setDepartments] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [unpublishedAttendance, setUnpublishedAttendance] = useState([]);

  useEffect(() => {
    userLessonUserList({ lessonId, courseId }).then(data => {
      setUnpublishedAttendance(data.users.map(user => user[8]));
      setEmployees(data.users);
      const mappedAttendance = data.users.map(user => ({
        id: user[5],
        attended: user[4],
      }));
      setInitialAttendanceState(mappedAttendance);
      setDepartments(data.departments);
      setTerminals(data.terminals);
      setJobTitles(data.jobTitles);
      setIsLoading(false);
    });
  }, [lessonId, courseId]);

  return {
    employees,
    initialAttendanceState,
    setInitialAttendanceState,
    departments,
    terminals,
    jobTitles,
    unpublishedAttendance,
  };
};

export default useFetch;
